"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebBDataLoader = exports.AndroidBDataLoader = exports.IosBDataLoader = exports.BDataLoader = void 0;
const web_ui_framework_1 = require("@gruposantander/web-ui-framework");
const constants_1 = require("./constants");
class BDataLoader extends web_ui_framework_1.ScriptLibraryLoader {
    constructor(urls) {
        super('BData', constants_1.LOAD_CONFIG);
        this.urls = urls;
    }
    getUrls() {
        return this.urls;
    }
}
exports.BDataLoader = BDataLoader;
class IosBDataLoader extends BDataLoader {
    constructor(baseUrl, slaveUrl) {
        super([baseUrl, slaveUrl]);
    }
}
exports.IosBDataLoader = IosBDataLoader;
class AndroidBDataLoader extends BDataLoader {
    constructor(url) {
        super([url]);
    }
}
exports.AndroidBDataLoader = AndroidBDataLoader;
class WebBDataLoader extends BDataLoader {
    constructor(url) {
        super([url]);
    }
}
exports.WebBDataLoader = WebBDataLoader;
//# sourceMappingURL=index.js.map